module.exports = __webpack_public_path__ + "static/media/25542387_1703511316390719_4167417550401815477_o.2be86446.jpg";